import StyledSvg from '@gef-ui/material-svg-shared/StyledSvg';
import * as React from 'react';
const SvgPohledvkyLogoPrimaryBox = (props)=>{
    return /*#__PURE__*/ React.createElement(StyledSvg, {
        xmlns: "http://www.w3.org/2000/svg",
        width: 40,
        height: 40,
        fill: "none",
        viewBox: "0 0 40 40",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#C0200D",
        d: "M37.319 40H2.683A2.68 2.68 0 0 1 0 37.319V2.68A2.683 2.683 0 0 1 2.683 0H37.32A2.68 2.68 0 0 1 40 2.681V37.32A2.68 2.68 0 0 1 37.319 40"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M30.005 13.783c0-3.69-2.894-6.69-6.5-6.783H10l.005 20.345h6.665l.006-6.761 6.83-.024c3.605-.09 6.499-3.09 6.499-6.777M22.6 10.5h-6v6h6z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M29.99 30.795H10V33h19.99z"
    }));
};
export default SvgPohledvkyLogoPrimaryBox;
